import { render, staticRenderFns } from "./mixBoard.vue?vue&type=template&id=13c175c4&scoped=true"
import script from "./mixBoard.vue?vue&type=script&lang=js"
export * from "./mixBoard.vue?vue&type=script&lang=js"
import style0 from "./mixBoard.vue?vue&type=style&index=0&id=13c175c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c175c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c175c4')) {
      api.createRecord('13c175c4', component.options)
    } else {
      api.reload('13c175c4', component.options)
    }
    module.hot.accept("./mixBoard.vue?vue&type=template&id=13c175c4&scoped=true", function () {
      api.rerender('13c175c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/mixBoard.vue"
export default component.exports